import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ROLES from "constants/roles";
import { BlockLink } from "../../components/Animations";
import disability from "../../assets/images/doctor.png";
import divorce from "../../assets/images/latest/Divorce.png";
import destruction from "../../assets/images/calculator.png";
import death from "../../assets/images/casket.png";
import disaster from "../../assets/images/latest/Disaster.png";
import PageTitle from "components/layout/PageTitle";
import ModalVideo from "../../newComponents/ModuleVideos/ModalVideo";

class Protector extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}
  hasPermission(checkPermissions = []) {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
    return checkPermissions.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  }

  render() {
    const block_links = [
      {
        href: "/protector/disability/dashboard",
        title: "Disability",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: disability,
        permission: ["Super Admin","create client module"],
      },
      {
        href: "/protector/divorce/dashboard",
        title: "Divorce",
        visible: this.props.user.role == ROLES.FREE_APP_SUITE ? false : true,
        img: divorce,
        permission: ["Super Admin","create client module"],
      },
      // {
      //     href: '/destruction',
      //     title: 'Destruction',
      //     visible: (this.props.user.role == ROLES.FREE_APP_SUITE) ? false : true,
      //     img: destruction
      // },
      {
        href: "/protector/death/dashboard",
        title: "Death (When I Die)",
        visible: true,
        img: death,
        permission: [
          "Confirm Death",
          "Get Client Death Url",
          "Send Otp in Death Module",
          "Revert Death Status",
          "Cleint Death Status",
          "Create Death Status Revert Time",
          "Send Emails And Text In Death Module",
          "Save Client Death Url",
          "Super Admin",
        ],
      },
      {
        href: "/protector/disaster/dashboard",
        title: "Disaster",
        visible: true,
        img: disaster,
        permission: ["Super Admin","create client module"],
      },
    ];

    return (
      <React.Fragment>
        <div className="page-nav-history">
          <div style={{ marginBottom: "5em" }}>
            <PageTitle title="Protector" />
          </div>
        </div>
        <ModalVideo module="Protector" autoOpen={true} />
        <div className="module-blocks">
          {block_links.map((blocklink, bindex) => {
            return (
              <div key={bindex} className="module-block-link">
                <Link
                  to={{
                    pathname: blocklink.href,
                    state: { title: blocklink.title },
                  }}
                  style={{
                    pointerEvents: this.hasPermission(blocklink.permission)
                      ? ""
                      : "none",
                  }}>
                  <div
                    className={"button-wrap-goals"}
                    style={{
                      cursor: this.hasPermission(blocklink.permission)
                        ? ""
                        : "not-allowed",
                      pointerEvents: this.hasPermission(blocklink.permission)
                        ? ""
                        : "none",
                      opacity: this.hasPermission(blocklink.permission)
                        ? "1"
                        : "0.5",
                    }}>
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2 mb-2">
                        <img src={blocklink.img} className="img-btn" />
                      </div>
                      <div className="col-12 mb-2 mt-2">{blocklink.title}</div>
                    </div>
                  </div>
                </Link>
              </div>
            );
            {
              /* if (this.hasPermission(blocklink.permission)) {
              return (
                <BlockLink
                  key={bindex}
                  img={blocklink.img}
                  className="module-block-link"
                  style={{ opacity: "0.5" }}
                  link={blocklink.href}
                  title={blocklink.title}
                />
              );
            } else {
              return <React.Fragment></React.Fragment>;
            } */
            }
          })}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.rootReducer.loginUser.loginUserData,
  };
};
export default connect(mapStateToProps, null)(Protector);
